import { collection, doc, setDoc} from "firebase/firestore";

import { firestoreDb } from "../firebase";
import { JOBS } from "../constants";

const addJob = async (jobObj: Job) => {
  try {
    const jobRef = doc(collection(firestoreDb, JOBS));
    await setDoc(jobRef, {
      ...jobObj,
      id: jobRef.id
    });
    return jobRef.id;
  } catch (e) {
    console.error("Error adding job: ", e);
  }
}

const JobService = {
  addJob
}

export default JobService;
